exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2IQ_N9f2xGOnLWyjqzfjFS div {\n    border-color: #FFCB04;\n}", ""]);

// exports
exports.locals = {
	"ripple": "_2IQ_N9f2xGOnLWyjqzfjFS"
};